import React from "react";
import {Panel} from "react-bootstrap";
import Component from "../../components/AscComponent";
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb";


export default class CallCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };
    }

    panelOnClick = (path) => {
        this.props.historyPush({
            pathname: path,
        });
    };

    render() {
        const callCategoryTagPermission = this.getPermission("CallCategoryTag", "CallCategory");
        const autoTagRulePermission = this.getPermission("AutoTagRule", "CallCategory");

        const isCallCategoryTagVisible = !!(callCategoryTagPermission && callCategoryTagPermission.read);
        const isAutoTagRuleVisible = !!(autoTagRulePermission && autoTagRulePermission.read);
        const hasAnyVisiblePanel = isCallCategoryTagVisible || isAutoTagRuleVisible;

        return (
            <React.Fragment>
                <SetBreadCrumb displayItems={[{ name: this.props.langText.Body.CallCategory }]} />
                {!hasAnyVisiblePanel && (
                    <div className="no-readable-panels-message text-danger">
                        {this.props.langText.Message.NoVisiblePanelByAuth}
                    </div>
                )}
                <div className="flex-style">
                    {isCallCategoryTagVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("CallCategory/CallCategoryTag")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.CallCategoryTag}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.CallCategoryTagDescription}
                            </Panel.Body>
                        </Panel>
                    }

                    {isAutoTagRuleVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("CallCategory/AutoTagRule")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.AutoTagRuleV2}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.AutoTagRuleDescription}
                            </Panel.Body>
                        </Panel>
                    }
                </div>
            </React.Fragment>
        );
    }
}
